import { configureStore } from "@reduxjs/toolkit";
import { clearLocalStorageExcept } from '../utils/storage';
import mapSliceReducer from "../reducers/MapSlice";
import userSlice from "../reducers/userSlice";
import predictionSlice from "../reducers/PredictionSlice";
import MaskingSlice from "../reducers/MaskingSlice";
import categoriesReducer from '../reducers/CategoriesSlice';
import landDegradationReducer from '../reducers/LandDegradationSlice';


const rootReducer = (state, action) => {
  if (action.type === 'RESET_STORE_EXCEPT_USER_CATEGORIES') {
    // Preserve only user and categories state
    const { userState, categories } = state;
    state = { userState, categories };
  }

  if(action.type === 'RESET_STORE') {
    const {mapState, userState, predictionStore, categories, landDegradation} = state;
    state = {mapState, userState, predictionStore, categories, landDegradation}
  }
  
  return {
    mapState: mapSliceReducer(state?.mapState, action),
    userState: userSlice(state?.userState, action),
    predictionState: predictionSlice(state?.predictionState, action),
    maskingState: MaskingSlice(state?.maskingState, action),
    categories: categoriesReducer(state?.categories, action),
    landDegradation: landDegradationReducer(state?.landDegradation, action),
  };
};

export default configureStore({
  reducer: rootReducer
});